import React from "react";
import { Table, Thead, Tr, Th } from "@lightspeed/cirrus-table";

import { Card } from "@lightspeed/flame/Card";

import Row from "./cardTable/Row";
import Loader from "../Loader";

const CardTable = ({
  title = "Title",
  data,
  shopShow,
  d365DimensionsList = [],
  isD365Integration = false,
}) => {
  if (!data || data.length === 0 || !Array.isArray(data)) {
    return <Loader />;
  }

  return (
    <Card top="true">
      <div className="card-table-title">{title}</div>
      <Table>
        <Thead>
          <Tr>
            <Th width="15%">Company Id </Th>
            {shopShow && <Th width="15%">Shop Id </Th>}
            <Th width="14%">Account Id (Credit) </Th>
            <Th width="20%">Account Name (Credit) </Th>
            <Th width="14%">Account Id (Debit) </Th>
            <Th width="20%">Account Name (Debit) </Th>
            <Th width="20%">Class/Dep/Loc (Debit) </Th>
            <Th width="20%">Class/Dep/Loc (Credit) </Th>
            {isD365Integration && <Th width="12%">Dimensions</Th>}
            <Th width="10%" textAlign="right">
              Actions{" "}
            </Th>
          </Tr>
        </Thead>
        <tbody>
          <Row
            shopShow={shopShow}
            item={data[0]}
            d365DimensionsList={d365DimensionsList}
            isD365Integration={isD365Integration}
          />
        </tbody>
      </Table>
    </Card>
  );
};

export default CardTable;

